export const INDUSTRY_FOOD_PROCESSING_AND_DISTRIBUTION = "FOOD_PROCESSING_AND_DISTRIBUTION";
export const INDUSTRY_CATERING = "CATERING";
export const INDUSTRY_RETAIL = "RETAIL";
export const INDUSTRY_EDUCATION_AND_TEACHING = "EDUCATION_AND_TEACHING";
export const INDUSTRY_HEALTH_AND_SOCIAL_SERVICES = "HEALTH_AND_SOCIAL_SERVICES";
export const INDUSTRY_TRANSPORT = "TRANSPORT";
export const INDUSTRY_OTHER = "OTHER";
